<template>
  <div :class="[embeddedMode ? '' : 'mx-6 my-4']">
    <div class="md:flex md:items-center md:justify-between md:space-x-5">
      <div class="flex items-center space-x-5 w-full">
        <div class="flex-shrink-0">
          <div v-if="!embeddedMode" class="relative bg-purple-600/70 rounded-xl p-1">
            <mdicon name="text-search" size="62" class="text-purple-100" aria-hidden="true"></mdicon>
          </div>
          <div v-else class="relative bg-violet-600/70 rounded-md p-1">
            <mdicon name="text-search" size="30" class="text-violet-100" aria-hidden="true"></mdicon>
          </div>
        </div>
        <div class="w-full">
          <div class="relative">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <MagnifyingGlassIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
            <input
              id="search"
              name="search"
              v-model="searchQuery"
              class="block w-full rounded-md border-0 bg-white py-1.5 pl-10 pr-3 text-gray-900 ring-1 ring-inset ring-purple-500/50 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-purple-500 sm:text-md sm:leading-6"
              placeholder='Enter keywords or "quoted phrase" to Search audit events'
              type="search"
              @keyup.enter="loadData"
            />
          </div>
        </div>
      </div>

      <div class="flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
        <ProgressButton ref="searchProgressButton" title="Search" icon="text-search" @click="loadData"></ProgressButton>
        <!--<button
          class="flex items-center gap-x-1 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          @click="loadData"
        >
          <ArrowDownCircleIcon class="-ml-1.5 h-5 w-5" aria-hidden="true" />
          Export
        </button>-->
      </div>
    </div>

    <FiltersList :class="[embeddedMode ? 'mt-4' : 'mt-2']" @select-filter="onSelectFilter" @show-filters="showFilters"></FiltersList>

    <!--
    <div class="overflow-hidden mt-2">
      <div class="flex items-center justify-between border-b border-gray-300 pb-1">
        <div class="flex items-center">
          <mdicon name="text" size="18" class="rounded-md bg-emerald-600/70 p-1 mr-2 text-white" aria-hidden="true"></mdicon>
          <h2 class="text-base font-semibold leading-7 text-gray-900">
            <span class="text-lg text-slate-800 font-semibold">{{ auditSearchStore.auditRecordsTotal }}</span>
            conversations over
            <span class="text-md text-slate-700">{{ analyzedDateRange }} (UTC)</span>
          </h2>
        </div>
        <div class="flex items-center"></div>
      </div>
      <DbUplot
        v-if="auditSearchStore.auditRecordsTotal > 0"
        class="w-full h-[160px] mt-2 bg-gray-100/50 rounded-xl"
        :data="uPlotData"
        :options="uPlotOptions"
        @db-event="handleDbEvent"
        :tooltip="true"
        :title="`${auditSearchStore.auditRecordsTotal} Conversations`"
        tz="Etc/UTC"
      ></DbUplot>
    </div>

    -->

    <div class="mt-2">
      <DataTable
        :value="auditRecords"
        lazy
        paginator
        :first="auditSearchStore.searchOffset"
        :rows="25"
        dataKey="id"
        :totalRecords="totalRecords"
        sortField="datetime"
        :sortOrder="-1"
        removableSort
        @page="onPage($event)"
        @sort="onSort($event)"
        size="small"
        scrollable
        tableStyle="min-width: 50rem"
        filterDisplay="menu"
        v-model:filters="tableFiltersSpec"
      >
        <Column field="action" header="Action">
          <template #body="slotProps">
            <div class="">{{ slotProps.data?.action }}</div>
          </template>
        </Column>
        <Column field="description" header="Description">
          <template #body="slotProps">
            <div class="">{{ slotProps.data?.description }}</div>
          </template>
        </Column>
        <Column field="Name" header="Document" sortable>
          <template #body="slotProps">
            <div class="font-medium">
              {{ getDocumentName(slotProps.data?.object_id, slotProps.data?.metadata?.name) }}
            </div>
          </template>
        </Column>
        <Column field="object_id" header="Document ID" :showFilterMenu="false" :showFilterMatchModes="false" :showClearButton="false" :showApplyButton="false" sortable>
          <!--
          <template #filter="">
            <EditFilter :filter="getDocumentName(filtersStore.getFilter('object_id'))" class="p-2 m-2"></EditFilter>
          </template>
          -->
          <template #body="slotProps">
            <div class="flex cursor-pointer items-center hover:underline" @click="onSetFilter('object_id', [slotProps.data?.object_id || null])">
              <div class="cursor-pointer font-medium">
                {{ slotProps.data?.object_id }}
              </div>
              <mdicon name="filter" size="20" class="ml-2 text-gray-300"></mdicon>
            </div>
          </template>
        </Column>
        <Column field="user.name" header="User" :showFilterMenu="false" :showFilterMatchModes="false" :showClearButton="false" :showApplyButton="false" sortable>
          <template #filter="">
            <EditFilter :filter="filtersStore.getFilter('user.name')" class="p-2 m-2"></EditFilter>
          </template>
          <template #body="slotProps">
            <div class="flex cursor-pointer items-center hover:underline" @click="onSetFilter('user.name', [slotProps.data?.user?.name || null])">
              <div class="cursor-pointer font-medium">{{ slotProps.data?.user?.name || '-' }}</div>
              <mdicon name="filter" size="20" class="ml-2 text-gray-300"></mdicon>
            </div>
          </template>
        </Column>
        <Column field="datetime" header="Date" sortable>
          <template #body="slotProps">
            <div class="">{{ dayjs(slotProps.data?.datetime).format('MM/DD/YY HH:mm:ss') }}</div>
          </template>
        </Column>
      </DataTable>
    </div>
    <EditFiltersSidebar v-model:visible="filtersOpen"></EditFiltersSidebar>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useKbAuditSearchStore } from '@/store/KbAuditStore';
  import { useDateRangeStore } from '@/store/DaterangeStore';
  import { useAuditFiltersStore } from '@/store/KbAuditFiltersStore';
  import { useKbStore } from '@/store/KbStore';
  import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import dayjs from 'dayjs';
  import ProgressButton from '@/components/Buttons/ProgressButton.vue';
  import EditFiltersSidebar from '@/components/Filters/EditFiltersSidebar.vue';
  import FiltersList from '@/components/Filters/FiltersList.vue';

  const route = useRoute();
  const auditSearchStore = useKbAuditSearchStore();
  const dateRangeStore = useDateRangeStore();
  const filtersStore = useAuditFiltersStore();

  const kbStore = useKbStore();
  const q = decodeURIComponent(route?.query?.query || '');
  const queryFilter = route?.query?.filter || null;
  const searchQuery = ref(q);
  const embeddedMode = ref(route.meta?.embeddedMode === 'true');
  const analyzedDateRange = ref('');
  const kbId = route.params?.id || null;

  const searchProgressButton = ref(null);

  const filtersOpen = ref(false);
  const tableFiltersSpec = ref({
    botName: { value: null },
    User: { value: null },
  });

  // Search Results Table
  //const dt = ref();
  const loading = ref(false);
  const totalRecords = computed(() => auditSearchStore.auditRecordsTotal);
  const auditRecords = computed(() => auditSearchStore.auditRecords);

  watch(filtersStore.allFilters, (newValue) => {
    if (loading.value) {
      return;
    }
    console.log(`Filters changed: ${JSON.stringify(newValue)}`);
    loadData();
  });

  watch(
    () => dateRangeStore.timeIntervalChanged,
    (newValue) => {
      console.log(`Date range changed: ${JSON.stringify(newValue)}`);
      loadData();
    },
  );

  const onPage = async (event) => {
    console.log(`onPage: ${JSON.stringify(event)}`);
    if ('first' in event && 'rows' in event) {
      loading.value = true;
      await auditSearchStore.page(event.first, event.rows);
      loading.value = false;
    }
  };

  const onSort = async (event) => {
    console.log(`onSort: ${JSON.stringify(event)}`);
    // [{field:'name',type:'asc|desc'},...]
    if ('sortField' in event && 'sortOrder' in event) {
      const sortFields = [
        {
          field: event?.sortField || 'datetime',
          type: event?.sortOrder === 1 ? 'asc' : 'desc',
        },
      ];
      loading.value = true;
      await auditSearchStore.sort(sortFields);
      loading.value = false;
    }
  };

  async function loadData() {
    searchProgressButton.value.startProgress();
    loading.value = true;
    // load kbstore:
    if (!kbStore.kbSpec.value) {
      await kbStore.loadKb(kbId);
      console.log(`Loaded KB: ${kbId}`);
    }
    //const filters = [{ type: 'match_phrase', field: 'state.leadType', value: 'hot' }];
    await auditSearchStore.search(searchQuery.value, 25, 0, [{ field: 'datetime', type: 'desc' }], true);
    loading.value = false;
    if (searchProgressButton.value) {
      searchProgressButton.value.stopProgress();
    }
    const startDate = dateRangeStore.fromTs;
    const endDate = dateRangeStore.toTs;
    analyzedDateRange.value = `${dayjs(startDate).utc().format('YYYY-MM-DD')} - ${dayjs(endDate).utc().format('YYYY-MM-DD')}`;
  }

  function onSetFilter(field, value) {
    filtersStore.setFilterValue(field, value);
  }

  function onSelectFilter(filter) {
    // TODO pass which filter to make active
    showFilters();
  }

  function showFilters() {
    filtersOpen.value = true;
  }

  function setFiltersFromQuery() {
    if (!queryFilter || queryFilter === '') {
      return;
    }
    const f = Array.isArray(queryFilter) ? queryFilter : [queryFilter];
    if (f.length <= 0) {
      return;
    }
    const fDefs = f.map((x) => decodeURIComponent(x));
    console.log(`Setting up filters from query:`, fDefs);
    let from = 0;
    let to = 0;
    fDefs.map((x) => {
      let xp = x.split(':');
      if (Array.isArray(xp) && xp.length === 2) {
        switch (xp[0]) {
          case 'from': {
            from = parseInt(xp[1]);
            break;
          }
          case 'to': {
            to = parseInt(xp[1]);
            break;
          }
          default: {
            filtersStore.setFilterValue(xp[0], [xp[1]]);
            break;
          }
        }
        return;
      }
      xp = x.split('>');
      if (Array.isArray(xp) && xp.length === 2) {
        filtersStore.setRangeFilterValue(xp[0], 'gte', [xp[1]]);
      }
    });
    // Update date filter, if set
    if (from > 0 && to > 0) {
      dateRangeStore.setDateRange(from, to);
    }
  }

  function getDocumentName(id, altName) {
    const docMetadata = kbStore.getDocumentInfoByMetadata({ id });
    return docMetadata?.name || docMetadata?.metadata?.title || altName || `Deleted Document '${id}'`;
  }

  onMounted(() => {
    if (!kbId) {
      console.log(`ERROR: KB ID must be specified`);
      return;
    }
    filtersStore.setFilterValue('metadata.kb_id', kbId);
    setFiltersFromQuery();

    // [re-]Load conditionally
    let needLoad = false;
    if (dateRangeStore.isChangedSince(auditSearchStore.searchTimeIntervalTs)) {
      needLoad = true;
    }

    if (filtersStore.isChangedSince(auditSearchStore.searchTimeIntervalTs)) {
      needLoad = true;
    }

    if (needLoad) {
      searchProgressButton.value.startProgress();
      loadData(kbId);
    }
  });
</script>
